import { css } from '@emotion/css'
import { fontSize, fontWeight, spacing, colors } from '@offerzen/pinata-shame'

const styles = {
  card: css({
    display: 'flex !important', // Override Pinata default.
    flexDirection: 'column',
    padding: spacing.large,
    gap: spacing.medium,
  }),

  applyHeading: css({
    fontSize: fontSize.default,
    fontWeight: fontWeight.semiBold,
  }),

  requirementListHeading: css({
    fontWeight: fontWeight.semiBold,
    color: colors.scorpion,
  }),
}

export default styles
